<h1 mat-dialog-title>
  {{ data?.type === 'rides' ? 'Ritten exporteren' : 'Exporteren' }}{{ !data?.onlyExport ? '/importeren' : '' }}
</h1>
<div mat-dialog-content>
  <form [formGroup]="exportImportForm">
    @if (!data?.onlyExport) {
      <mat-radio-group aria-label="Select an option" formControlName="type">
        @for (option of options; track option) {
          <mat-radio-button [value]="option" [checked]="option.checked">{{ option.name }}</mat-radio-button>
        }
      </mat-radio-group>
    }
    @if (data?.type === 'rides') {
      @if (selectedOption.value === 'Export') {
        <mat-form-field>
          <mat-label>Ik wil {{ selectedOption.name.toLowerCase() }} vanaf</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="startFrom" />
          <mat-datepicker-toggle matSuffix aria-label="Kalender openen" [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      }
      @if (selectedOption.value === 'Import') {
        <mat-error>Let op: bij het importeren worden ritten met hetzelfde ID overschreven.</mat-error>
      }
    }
    @if (data?.type === 'users' || data?.type === 'admin-users') {
      @if (selectedOption.value === 'Export') {
        <mat-form-field>
          <mat-label>{{ data?.type === 'users' ? 'Passagiers' : 'Medewerkers' }} exporteren</mat-label>
          <mat-select formControlName="usersToExport">
            <mat-option value="all">
              Alle {{ data?.type === 'users' ? 'passagiers' : 'medewerkers' }}, inclusief verborgen
            </mat-option>
            <mat-option value="current">Huidige weergave </mat-option>
            <mat-option value="filtered"> Huidige gefilterde weergave </mat-option>
          </mat-select>
        </mat-form-field>
      }
      @if (selectedOption.value === 'Import') {
        <div class="import-warning">
          <div>
            Let op: bij het importeren wordt gekeken naar het
            {{ data?.type === 'users' ? 'Passagier' : 'Medewerker' }}-ID.
          </div>
          <div>
            Als dit ID niet bestaat, gaan we ervan uit dat het om een nieuwe
            {{ data?.type === 'users' ? 'passagier' : 'medewerker' }} gaat.
          </div>
          <div>
            We maken eerst een account aan met het e-mailadres. Bestaat dat niet, dan gebruiken we het telefoonnummer.
          </div>
          <div>We ondersteunen de volgende formaten: <b>0611223344</b> en <b>+31611223344</b>.</div>
          <div>
            <b>{{
              data?.type === 'users'
                ? 'Er zijn meerdere velden die niet worden overschreven bij het importeren: Plannaam, Aangemaakt op, Rol en Credits.'
                : 'Er is één veld dat niet wordt overschreven bij het importeren: Rol.'
            }}</b>
          </div>
        </div>
      }
    }
    @if (data?.type === 'audits') {
      <mat-slide-toggle formControlName="showTime">Tijd laten zien bij de datum</mat-slide-toggle>
    }
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annuleren</button>
  <button mat-flat-button (click)="save()" [disabled]="exportImportForm.invalid">
    {{ selectedOption.value === 'Export' ? 'Exporteren' : 'Importeren' }}
  </button>
</div>
